import CoreScroll from '../core-scroll'


export default
{
    name: 'app-fixed',

    mixins:
    [
        CoreScroll
    ],

    props:
    {
        absToTop: { type: String }
    },

    mounted()
    {
        const isFakeScroll = this.$root.isFakeScroll
        
        this.isFakeScroll = isFakeScroll
        this.onScroll(this.scroll.smoothY)
    },

    methods: {

        onScroll(y)
        {
            if (this.isFakeScroll)
            {
                let rule = 'translateY(' + y.toFixed(0) + 'px) translateZ(0)'
                if (this.absToTop)
                {
                    rule += ' ' + this.absToTop
                }
                this.$el.style.transform = rule
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/mixins/app-fixed/index.js